import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CategoryApiService } from 'src/modules/category/services/category-api-service';
import { EventApiService } from 'src/modules/event/services/event-api-service';

@Component({
    selector: 'category-delete-modal',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class CategoryDelete implements OnInit, OnDestroy {
  public Category;
  constructor(
    @Inject(MAT_DIALOG_DATA) private config,
    protected dialogRef: MatDialogRef<CategoryDelete>,
    public Api: CategoryApiService
  ) {}
  ngOnInit(): void {
    this.Category = this.config;
  }

  deleteCategory(category) {
    const { id } = category;
    return this.Api.deleteCategory('admin', id).then((categoryId) =>
      this.dialogRef.close(categoryId)
    );
  }

  ngOnDestroy(): void {}
}
